// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"28e38bba","110":"7fe95281","206":"d265a34d","294":"ea544204","717":"42c61826","770":"3b3c5f5a","959":"37330b1a"}[chunkId] + ".chunk.css";
};